<template>
    <v-app>
        <Header/>
        <transition name="fade" mode="out-in">
            <router-view/>
        </transition>
        <Footer/>
    </v-app>
</template>

<script>
    import Header from "@/components/base/mps/Header";
    import Footer from "@/components/base/mps/Footer";

    export default {
        name: "masterMps",
        components: {
            Header,
            Footer,
        },
        data: () => ({
            //
        }),
    };
</script>
